import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Utility class for generating a bunch of cheap and fast unique id's.
 * These ids are not globally unique.
 */
export class LocallyUniqueIdSet {
  constructor(usedKeySet) {
    _defineProperty(this, "usedKeySet", void 0);
    _defineProperty(this, "generateId", () => {
      let id = undefined;
      while (id === undefined || this.usedKeySet.has(id)) {
        id = Math.random().toString(36).substring(2, 15);
      }
      this.usedKeySet.add(id);
      return id;
    });
    this.usedKeySet = usedKeySet ?? new Set();
  }
}
//# sourceMappingURL=LocallyUniqueIdSet.js.map
